import { GetStaticProps } from 'next';
import AboutPage from '../../components/elements/AboutPage';
import { Card } from '../../components/ui/TabBox';
import { ABOUT_PAGE } from '../../queries/about';
import { AcademyAboutUs } from '../../types/schema';
import { initializeApollo } from '../../utils/apollo';
import { flatten } from '../../utils/object';
import rollbar from '../../utils/rollbar';

const sobre: React.FC<{ aboutPage: AcademyAboutUs }> = ({ aboutPage }) => {
  const metaImageUrl = aboutPage.metadata?.metaImage?.data?.attributes.url || '';
  const bannerImageUrl = aboutPage.bannerImg?.data?.attributes.url || '';
  const imageUrl = aboutPage.image?.data?.attributes.url || '';

  return (
    <AboutPage
      metaTitle={aboutPage.metadata?.metaTitle as string}
      metaDescription={aboutPage.metadata?.metaDescription as string}
      metaImage={metaImageUrl}
      bannerImg={bannerImageUrl}
      bannerTitle={aboutPage.bannerTitle as string}
      title={aboutPage.title as string}
      description={aboutPage.description as string}
      valuesDescription={aboutPage.valuesDescription as string}
      image={imageUrl}
      cards={aboutPage.cards as Card[]}
    />
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo();

  try {
    const { data } = await apolloClient.query({
      query: ABOUT_PAGE,
    });

    const newData = flatten(data);

    return {
      props: {
        aboutPage: newData.academyAboutUs,
      },
      revalidate: 60,
    };
  } catch (error) {
    rollbar.error('Error fetching about page', { error });
    return {
      notFound: true,
    };
  }
};

export default sobre;
